import Carousel from './Carousel.vue'
import CarouselItem from './CarouselItem.vue'

// 定义组件名称
const CAROUSEL_NAME = 'OlaCarousel'
const CAROUSEL_ITEM_NAME = 'OlaCarouselItem'

Carousel.Item = CarouselItem

/**
 * 安装 Carousel 组件
 * @param {import('vue').App} app - Vue 应用实例
 */
Carousel.install = function(app) {
  app.component(CAROUSEL_NAME, Carousel)
  app.component(CAROUSEL_ITEM_NAME, CarouselItem)
}

export { Carousel, CarouselItem }
export default Carousel


